import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { OpenCalenderInvite } from '../../Bookings/utils/CalenderInvite';
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import moment from 'moment';
import { getUrls } from '../../config';
import { defaultScale } from '../../utils';

export default class AddToCalendarButtons extends Component {

    render() {
        const { t, workoutSession, useNormalButtons, displayHorizontal } = this.props;
        var calendarEventProperties = {
            calenderUrl: getUrls().CALENDAR_BOOKING,
            title: "Fitillion workout",
            start: moment(workoutSession.startTimeOfFirstExercise).format('LLL'),
            end: moment(workoutSession.endTime).format('LLL'),
            location: "",
            description:
                "Reschedule or cancel this workout in the app."
        };

        const googleCalendarButton = (
          <Button
            title={t('googleCal')}
            containerStyle={displayHorizontal && { flex: 1, marginRight: defaultScale(7) }}
            fontColor={useNormalButtons ? Theme.WHITE : Theme.PRIMARY}
            buttonType={useNormalButtons ? ButtonTypes.NORMAL : ButtonTypes.OUTLINE}
            onPress={() => OpenCalenderInvite(`${calendarEventProperties.calenderUrl}?title=${calendarEventProperties.title}&start=${calendarEventProperties.start}&end=${calendarEventProperties.end}&location=${calendarEventProperties.location}&description=${calendarEventProperties.description}&mailType=googleCal`)}
          />
        );

        const downloadIcsFileButton = (
          <Button
            title={t('downloadCal')}
            containerStyle={displayHorizontal && { flex: 1, marginLeft: defaultScale(7) }}
            fontColor={useNormalButtons ? Theme.WHITE : Theme.PRIMARY}
            buttonType={useNormalButtons ? ButtonTypes.NORMAL : ButtonTypes.OUTLINE}
            onPress={() => OpenCalenderInvite(`${calendarEventProperties.calenderUrl}?title=${calendarEventProperties.title}&start=${calendarEventProperties.start}&end=${calendarEventProperties.end}&location=${calendarEventProperties.location}&description=${calendarEventProperties.description}&mailType=ICS`)}
          />
        )

        return (
            <>
                {displayHorizontal &&
                  <View style={styles.displayHorizontal}>
                      {googleCalendarButton}
                      {downloadIcsFileButton}
                  </View>
                }
                {!displayHorizontal &&
                  <>
                      <View style={styles.calendarButton}>
                          {googleCalendarButton}
                      </View>
                      <View style={styles.calendarButton}>
                          {downloadIcsFileButton}
                      </View>
                  </>
                }
            </>
        )
    }
}

const styles = StyleSheet.create({
    calendarHeading: {
        fontSize: 25,
        color: Theme.CHARCOAL,
        fontFamily: Theme.CustomBold,
        paddingVertical: 5
    },
    calendarButton: {
        width: '100%',
        paddingVertical: 5,
    },
    displayHorizontal: {
        flexDirection: 'row',
        width: '100%',
        paddingHorizontal: defaultScale(20),
    }
});
